<template>
  <box title="Control Prenatal" icon="fa-solid fa-vial" :contraction="true">
    <section class="row">
      <div class="form-group col-12 col-md-4">
        <label>Sexo</label>
        <input type="text" class="form-control" :value="sexo" disabled />
      </div>
      <div class="form-group col-12 col-md-4">
        <label>Tipo de sangre</label>
        <input type="text" class="form-control" :value="tipoSangre" disabled />
      </div>
      <div class="form-group col-12 col-md-4">
        <label>Número de gestaciones</label>
        <input type="number" class="form-control" v-model="controlPrenatal.gestaciones" @change="saveControlPrenatal('gestaciones')" placeholder="Ingrese el número de gestaciones" />
      </div>
      <div class="form-group col-12 col-md-4">
        <label>Unidad de Reproducción</label>
        <input type="text" class="form-control" v-model="controlPrenatal.unidad_reproduccion" @change="saveControlPrenatal('unidad_reproduccion')" placeholder="Ejemplo: Unidad de fertilidad, clínica de reproducción, etc." />
      </div>
      <div class="form-group col-12 col-md-4">
        <label>USG (Ultrasonido)</label>
        <input type="text" class="form-control" v-model="controlPrenatal.usg" @change="saveControlPrenatal('usg')" placeholder="Ejemplo: USG transvaginal, obstétrico, fecha y hallazgos" />
      </div>
      <div class="form-group col-12 col-md-4">
        <label>DS (Diagnóstico Sindrómico)</label>
        <input type="text" class="form-control" v-model="controlPrenatal.ds" @change="saveControlPrenatal('ds')" placeholder="Ejemplo: Diagnóstico sindrómico, hallazgos relevantes" />
      </div>
      <div class="form-group col-12">
        <label>Ultrasonido</label>
        <textarea class="form-control" style="min-height: 140px;" v-model="controlPrenatal.ultrasonido" @change="saveControlPrenatal('ultrasonido')" placeholder="Describa los hallazgos, observaciones o recomendaciones del ultrasonido realizado"></textarea>
      </div>
    </section>
  </box>

  <box title="Ginecología General" icon="fas fa-venus" :contraction="true">
    <!-- Información General -->
    <section class="row mb-3">
      <div class="col-12">
        <h5 class="text-primary">Información General</h5>
      </div>
      <div class="form-group col-12 col-md-4">
        <label>Fecha de la consulta</label>
        <input type="date" class="form-control" v-model="infoGeneral.fecha" @change="saveInfoGeneral('fecha')" />
      </div>
      <div class="form-group col-12 col-md-4">
        <label>Ocupación</label>
        <input type="text" class="form-control" v-model="infoGeneral.ocupacion" @change="saveInfoGeneral('ocupacion')" placeholder="Ejemplo: Secretaria, estudiante, etc." />
      </div>
      <div class="form-group col-12 col-md-4">
        <label>Estado Civil</label>
        <input type="text" class="form-control" v-model="infoGeneral.estado_civil" @change="saveInfoGeneral('estado_civil')" placeholder="Ejemplo: Soltera, casada, etc." />
      </div>
    </section>
    <!-- Evaluación Actual / Motivo de Consulta -->
    <section class="row mb-3">
      <div class="col-12">
        <h5 class="text-primary">Evaluación Actual / Motivo de Consulta</h5>
      </div>
      <div class="form-group col-12 col-md-4">
        <label>TRH o ACOS</label>
        <input type="text" class="form-control" v-model="evaluacion.trh_acos" @change="saveEvaluacion('trh_acos')" placeholder="Terapia de reemplazo hormonal o anticonceptivos" />
      </div>
      <div class="form-group col-12 col-md-4">
        <label>G (Gestaciones)</label>
        <input type="number" class="form-control" v-model="evaluacion.g" @change="saveEvaluacion('g')" placeholder="Número de gestaciones (si aplica)" />
      </div>
      <div class="form-group col-12 col-md-4">
        <label>UR (Unidad de Reproducción)</label>
        <input type="text" class="form-control" v-model="evaluacion.ur" @change="saveEvaluacion('ur')" placeholder="Unidad de reproducción (si aplica)" />
      </div>
      <div class="form-group col-12 col-md-4">
        <label>Ciclos (menstruales)</label>
        <input type="text" class="form-control" v-model="evaluacion.ciclos" @change="saveEvaluacion('ciclos')" placeholder="Ejemplo: Regulares, irregulares, etc." />
      </div>
      <div class="form-group col-12 col-md-4">
        <label>DS (Diagnóstico Sospecha)</label>
        <input type="text" class="form-control" v-model="evaluacion.ds" @change="saveEvaluacion('ds')" placeholder="Diagnóstico de sospecha" />
      </div>
      <div class="form-group col-12 col-md-4">
        <label>DO (Diagnóstico Objetivo)</label>
        <input type="text" class="form-control" v-model="evaluacion.do" @change="saveEvaluacion('do')" placeholder="Diagnóstico objetivo" />
      </div>
      <div class="form-group col-12">
        <label>Ginecológico</label>
        <textarea class="form-control" v-model="evaluacion.ginecologico" @change="saveEvaluacion('ginecologico')" placeholder="Motivo de consulta o hallazgos ginecológicos"></textarea>
      </div>
      <div class="form-group col-12 col-md-4">
        <label>Papanicolaou</label>
        <input type="text" class="form-control" v-model="evaluacion.papanicolaou" @change="saveEvaluacion('papanicolaou')" placeholder="Fecha o resultado del último papanicolaou" />
      </div>
      <div class="form-group col-12 col-md-4">
        <label>Mamografía</label>
        <input type="text" class="form-control" v-model="evaluacion.mamografia" @change="saveEvaluacion('mamografia')" placeholder="Fecha o resultado de la última mamografía" />
      </div>
      <div class="form-group col-12 col-md-4">
        <label>Densitometría Ósea</label>
        <input type="text" class="form-control" v-model="evaluacion.densitometria" @change="saveEvaluacion('densitometria')" placeholder="Fecha o resultado de la última densitometría" />
      </div>
      <div class="form-group col-12">
        <label>Ultrasonido</label>
        <textarea class="form-control" style="min-height: 100px;" v-model="evaluacion.ultrasonido" @change="saveEvaluacion('ultrasonido')" placeholder="Observaciones o hallazgos del ultrasonido"></textarea>
      </div>
    </section>
  </box>

  <box title="Post Parto" icon="fas fa-baby" :contraction="true">
    <section class="row mb-3">
      <div class="col-12">
        <h5 class="text-primary">Seguimiento inmediato al parto</h5>
      </div>
      <div class="form-group col-12 col-md-4">
        <label>Fecha</label>
        <input type="date" class="form-control" v-model="postParto.fecha" @change="savePostParto('fecha')" />
      </div>
      <div class="form-group col-12 col-md-4">
        <label>Edad de la madre al momento del parto</label>
        <input type="number" class="form-control" v-model="postParto.edad_madre" @change="savePostParto('edad_madre')" placeholder="Edad en años" />
      </div>
      <div class="form-group col-12 col-md-4">
        <label>Parto (tipo de parto)</label>
        <input type="text" class="form-control" v-model="postParto.tipo_parto" @change="savePostParto('tipo_parto')" placeholder="Ejemplo: Cesárea, vaginal, etc." />
      </div>
      <div class="form-group col-12 col-md-4">
        <label>RN (Recién Nacido, info básica)</label>
        <input type="text" class="form-control" v-model="postParto.rn" @change="savePostParto('rn')" placeholder="Ejemplo: Sexo, Apgar, etc." />
      </div>
      <div class="form-group col-12 col-md-4">
        <label>PAN (Peso al Nacer)</label>
        <input type="number" class="form-control" v-model="postParto.pan" @change="savePostParto('pan')" placeholder="Peso en gramos" />
      </div>
      <div class="form-group col-12 col-md-4">
        <label>Hospital</label>
        <input type="text" class="form-control" v-model="postParto.hospital" @change="savePostParto('hospital')" placeholder="Nombre del hospital" />
      </div>
    </section>
  </box>

  <box title="Post Parto 40 Días" icon="fas fa-baby-carriage" :contraction="true">
    <section class="row mb-3">
      <div class="col-12">
        <h5 class="text-primary">Seguimiento posterior a la cuarentena</h5>
      </div>
      <div class="form-group col-12 col-md-3">
        <label>DS (Diagnóstico Sospecha)</label>
        <input type="text" class="form-control" v-model="postParto40.ds" @change="savePostParto40('ds')" placeholder="Ejemplo: Sospecha de infección, anemia, etc." />
      </div>
      <div class="form-group col-12 col-md-3">
        <label>DO (Diagnóstico Objetivo)</label>
        <input type="text" class="form-control" v-model="postParto40.do" @change="savePostParto40('do')" placeholder="Ejemplo: Diagnóstico confirmado tras exámenes" />
      </div>
      <div class="form-group col-12 col-md-3">
        <label>ND (Nota de Descarte)</label>
        <input type="text" class="form-control" v-model="postParto40.nd" @change="savePostParto40('nd')" placeholder="Ejemplo: Se descarta infección, hemorragia, etc." />
      </div>
      <div class="form-group col-12 col-md-3">
        <label>USG (Ultrasonido)</label>
        <input type="text" class="form-control" v-model="postParto40.usg" @change="savePostParto40('usg')" placeholder="Ejemplo: USG normal, hallazgos, fecha" />
      </div>
    </section>
  </box>
</template>

<script>
import Box from '/src/modules/medico/views/fichas/Box.vue';
import API from '/src/core/Api';
import { mapGetters } from 'vuex';

export default {
  name: 'ControlPrenatal',
  components: { Box },
  data() {
    return {
      controlPrenatal: {
        unidad_reproduccion: '',
        usg: '',
        ds: '',
        ultrasonido: '',
        gestaciones: ''
      },
      sexo: '',
      tipoSangre: '',
      infoGeneral: {
        fecha: '',
        ocupacion: '',
        estado_civil: ''
      },
      evaluacion: {
        trh_acos: '',
        g: '',
        ur: '',
        ciclos: '',
        ds: '',
        do: '',
        ginecologico: '',
        papanicolaou: '',
        mamografia: '',
        densitometria: '',
        ultrasonido: ''
      },
      postParto: {
        fecha: '',
        edad_madre: '',
        tipo_parto: '',
        rn: '',
        pan: '',
        hospital: ''
      },
      postParto40: {
        ds: '',
        do: '',
        nd: '',
        usg: ''
      }
    };
  },
  computed: {
    ...mapGetters({
      GetMedicoFichaActive: 'GetMedicoFichaActive',
      GetClienteMetada: 'GetClienteMetada',
    })
  },
  watch: {
    GetMedicoFichaActive: {
      handler(newVal) {
        if (!newVal) return;
        // Sexo desde datos del cliente
        this.sexo = newVal.cliente && newVal.cliente.genero ? (newVal.cliente.genero === 'F' ? 'Femenino' : 'Masculino') : '';
        // Tipo de sangre desde metadata del cliente
        if (this.GetClienteMetada && this.GetClienteMetada.datos_paciente) {
          this.tipoSangre = this.GetClienteMetada.datos_paciente.tipo_sangre || '';
        }
        // Control prenatal desde metadata orden
        if (newVal.metadata && newVal.metadata.control_prenatal) {
          this.controlPrenatal = {
            unidad_reproduccion: newVal.metadata.control_prenatal.unidad_reproduccion || '',
            usg: newVal.metadata.control_prenatal.usg || '',
            ds: newVal.metadata.control_prenatal.ds || '',
            ultrasonido: newVal.metadata.control_prenatal.ultrasonido || '',
            gestaciones: newVal.metadata.control_prenatal.gestaciones || ''
          };
        } else {
          this.controlPrenatal = {
            unidad_reproduccion: '',
            usg: '',
            ds: '',
            ultrasonido: '',
            gestaciones: ''
          };
        }
        // Cargar info_general_ginecologia
        if (newVal.metadata && newVal.metadata.info_general_ginecologia) {
          this.infoGeneral = {
            fecha: newVal.metadata.info_general_ginecologia.fecha || '',
            ocupacion: newVal.metadata.info_general_ginecologia.ocupacion || '',
            estado_civil: newVal.metadata.info_general_ginecologia.estado_civil || ''
          };
        } else {
          this.infoGeneral = { fecha: '', ocupacion: '', estado_civil: '' };
        }
        // Cargar evaluacion_ginecologia
        if (newVal.metadata && newVal.metadata.evaluacion_ginecologia) {
          this.evaluacion = {
            trh_acos: newVal.metadata.evaluacion_ginecologia.trh_acos || '',
            g: newVal.metadata.evaluacion_ginecologia.g || '',
            ur: newVal.metadata.evaluacion_ginecologia.ur || '',
            ciclos: newVal.metadata.evaluacion_ginecologia.ciclos || '',
            ds: newVal.metadata.evaluacion_ginecologia.ds || '',
            do: newVal.metadata.evaluacion_ginecologia.do || '',
            ginecologico: newVal.metadata.evaluacion_ginecologia.ginecologico || '',
            papanicolaou: newVal.metadata.evaluacion_ginecologia.papanicolaou || '',
            mamografia: newVal.metadata.evaluacion_ginecologia.mamografia || '',
            densitometria: newVal.metadata.evaluacion_ginecologia.densitometria || '',
            ultrasonido: newVal.metadata.evaluacion_ginecologia.ultrasonido || ''
          };
        } else {
          this.evaluacion = { trh_acos: '', g: '', ur: '', ciclos: '', ds: '', do: '', ginecologico: '', papanicolaou: '', mamografia: '', densitometria: '', ultrasonido: '' };
        }
        // Cargar post_parto
        if (newVal.metadata && newVal.metadata.post_parto) {
          this.postParto = {
            fecha: newVal.metadata.post_parto.fecha || '',
            edad_madre: newVal.metadata.post_parto.edad_madre || '',
            tipo_parto: newVal.metadata.post_parto.tipo_parto || '',
            rn: newVal.metadata.post_parto.rn || '',
            pan: newVal.metadata.post_parto.pan || '',
            hospital: newVal.metadata.post_parto.hospital || ''
          };
        } else {
          this.postParto = { fecha: '', edad_madre: '', tipo_parto: '', rn: '', pan: '', hospital: '' };
        }
        // Cargar post_parto_40
        if (newVal.metadata && newVal.metadata.post_parto_40) {
          this.postParto40 = {
            ds: newVal.metadata.post_parto_40.ds || '',
            do: newVal.metadata.post_parto_40.do || '',
            nd: newVal.metadata.post_parto_40.nd || '',
            usg: newVal.metadata.post_parto_40.usg || ''
          };
        } else {
          this.postParto40 = { ds: '', do: '', nd: '', usg: '' };
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    // Cargar metadatos requeridos al montar el componente
    this.$store.dispatch('FetchClienteMetadaBySlug', { slugs: ['datos_paciente'] });
    this.emitter.emit('medico-ficha-load', [
      'control_prenatal',
      'info_general_ginecologia',
      'evaluacion_ginecologia',
      'post_parto',
      'post_parto_40'
    ]);
  },
  methods: {
    saveControlPrenatal(field) {
      const self = this;
      API.send('POST', 'orders/metadata/save/', {
        orderId: self.GetMedicoFichaActive.orden.id,
        slug: 'control_prenatal',
        detail: { ...self.controlPrenatal },
        uniqueMeta: 1,
      }, function () {
        self.$emit('medico-ficha-notify', ['control_prenatal']);
      });
    },
    saveInfoGeneral(field) {
      API.send('POST', 'orders/metadata/save/', {
        orderId: this.GetMedicoFichaActive.orden.id,
        slug: 'info_general_ginecologia',
        detail: { ...this.infoGeneral },
        uniqueMeta: 1,
      }, () => {
        this.$emit('medico-ficha-notify', ['info_general_ginecologia']);
      });
    },
    saveEvaluacion(field) {
      API.send('POST', 'orders/metadata/save/', {
        orderId: this.GetMedicoFichaActive.orden.id,
        slug: 'evaluacion_ginecologia',
        detail: { ...this.evaluacion },
        uniqueMeta: 1,
      }, () => {
        this.$emit('medico-ficha-notify', ['evaluacion_ginecologia']);
      });
    },
    savePostParto(field) {
      API.send('POST', 'orders/metadata/save/', {
        orderId: this.GetMedicoFichaActive.orden.id,
        slug: 'post_parto',
        detail: { ...this.postParto },
        uniqueMeta: 1,
      }, () => {
        this.$emit('medico-ficha-notify', ['post_parto']);
      });
    },
    savePostParto40(field) {
      API.send('POST', 'orders/metadata/save/', {
        orderId: this.GetMedicoFichaActive.orden.id,
        slug: 'post_parto_40',
        detail: { ...this.postParto40 },
        uniqueMeta: 1,
      }, () => {
        this.$emit('medico-ficha-notify', ['post_parto_40']);
      });
    }
  }
};
</script>

<style scoped>
.form-group {
  margin-bottom: 1.5rem;
}
.text-primary {
  color: #007bff;
}
</style>
